<template lang="pug">
  LayoutPlain
    .container.align__center
      .row.justify-content-center
        .col-lg-6.col-md-10
          .pad_b--25
            h5 Generate <strong>new</strong> user (with blank form)
            .pad_t--10
              button.button.button-primary(@click="generateNewUser") Generate new user

          hr


          .pad_t--25
            h5 Select <strong>Test case</strong> user
            .row.pad_t--10
              .col
                select.eform--input_dropdown(v-model="testCase")
                  option(value="") Please select Test Case
                  option(value="1") Test Case 1
                  option(value="2") Test Case 2
                  option(value="3") Test Case 3
                  option(value="4") Test Case 4
                  option(value="5") Test Case 5
              .col-auto
                button.button.button-primary(@click="generateTestCaseUser", :disabled="!testCase") Generate test case user

</template>



<script>
  import shortid from 'shortid';
  import { mapFields } from 'vuex-map-fields';


  let defaultData = {
    Title: "EN",
    CountryCodeMobile: "60",
    MobilePhone: "136240805",
    Email: "ruennhuah.lee@affinhwang.com",
    AccountType: "CMA",
    AgreeTerms: false,
    AgreeTermsBursa: false,
    AnnualIncome: "005",
    ApproximateTradePerYear: 30,
    ApproximateTradingValue: 150000,
    BankAccountNo: "166010064785",
    BankJointAccount: false,
    BankName: "MBB",
    BirthCountry: "MY",
    BirthDate: new Date('1992-08-26'),
    Bumiputera: true,
    BusinessCountry: "MY",
    BusinessName: "Affin Hwang Investment Bank",
    BusinessNature: "FINANCIAL INTERMEDIARY",
    BusinessPosition: "FINANCIAL ANALYSTS",
    BusinessYears: 4,
    CdsConsolidationIndicator: false,
    DependantsNo: 0,
    EmploymentStatus: "EMPLOYED WITH FIXED INCOME IN MALAYSIA(PRIVATE SEC",
    FundSources: [2],
    Gender: "M",
    Guarantor: false,
    InvestmentObjectives: [5, 2],
    MailingBuildingName: "Flexus Signatures Suites",
    MailingCity: "Segambut",
    MailingCountry: "MY",
    MailingState: "WILAYAH PERSEKUTUAN",
    MailingStreetName: "Jalan Kuching",
    MailingUnitNo: "15-17",
    MailingZipcode: "51200",
    MalaysiaResident: true,
    MalaysiaTaxResident: true,
    MaritalStatus: "MARRIED",
    MobilePhone: "136240805",
    Nationality: "MY",
    Networth: "003",
    NewIdNo: "920826-10-5081",
    NokCountryCodeMobile: "60",
    NokIdNo: "950415-10-5082",
    NokName: "Damia Binti Othman",
    NokOccupation: "HOMEMAKER",
    NokPhoneNumber: "136282655",
    NokRelationship: "SPOUSE",
    PepType: "no",
    DomesticBorrowing: false,
    Race: "001",
    RegisteredBuildingName: "Flexus Signatures Suites",
    RegisteredCity: "Segambut",
    RegisteredCountry: "MY",
    RegisteredState: "WILAYAH PERSEKUTUAN",
    RegisteredStreetName: "Jalan Kuching",
    RegisteredUnitNo: "15-17",
    RegisteredZipcode: "51200",
    RelatedPersonAccount: false,
    RelatedToBankStaff: false,
    ResidentialBuildingName: "Flexus Signatures Suites",
    ResidentialCity: "Segambut",
    ResidentialCountry: "MY",
    ResidentialState: "WILAYAH PERSEKUTUAN",
    ResidentialStreetName: "Jalan Kuching",
    ResidentialUnitNo: "15-17",
    ResidentialZipcode: "51200",
    TaxResidentOutsideMalaysia: false,
    UsPerson: false,
    WealthSources: [9],
    YearsExperienceDerivatives: 2,
    YearsExperienceEquities: 3,
  };

  export default {
    name: 'Playground',

    data: () => ({
      clientCode: '',
      testCase: '',
    }),

    methods: {

      async generateNewUser() {
        try {
          let userId = shortid.generate(); 

          let response = await this.$axios.post('/NF2F/SaveAsDraft', {
            UserId: userId,
          });


          let { data: draftResponse } = await this.$axios.get('/nf2f/retrievedraft', {
            params: { userId }
          });


          let payload = draftResponse.ApplicationFormDetailsDto;

          payload.RelatedToBankStaff = null;
          payload.PageIndicator = 'applicant_details'
          payload.Nf2fApplicationDraftId = draftResponse.DraftId;
          payload.Email = 'ruennhuah.lee@affinhwang.com';

          await this.$axios.post('/nf2f/SaveAsDraft', payload);


          let test = await this.$axios.get('/nf2f/retrievedraft', {
            params: { userId }
          });

          this.$router.push({ name: 'goRegistration', query: { userId } });

        } catch(error) {
          console.log(error);
          this.$bvToast.toast(`An error has occured whilst trying to generate a new user`, {
            title: 'An error has occured',
            variant: 'danger',
            autoHideDelay: 3500
          })
        }
      },



      async generateTestCaseUser() {
        try {
          let userId = shortid.generate(); 

          let overridePayload = {
            Name: null,
            NewIdNo: null,
            IdNo: null            
          }

          if(this.testCase === '1') {
            overridePayload.Name = 'Joseph Leong';
            overridePayload.NewIdNo = '950307-07-5022';
          }
          if(this.testCase === '2') {
            overridePayload.Name = 'Christine Wong';
            overridePayload.NewIdNo = '920202-02-5992';
          }
          if(this.testCase === '3') {
            overridePayload.Name = 'Aaron Wong Lai';
            overridePayload.NewIdNo = '700101-44-6690';
          }
          if(this.testCase === '4') {
            overridePayload.Name = 'Yen Yen Yan';
            overridePayload.NewIdNo = '850919-91-5822';
          }
          // if(this.testCase === '5') {
          //   overridePayload.Name = 'Gerrard Kok Kok Siew';
          //   overridePayload.NewIdNo = '760229-72-3121';
          // }
          if(this.testCase === '5') { // Success payment
            overridePayload.Name = 'Catherine Ang';
            overridePayload.NewIdNo = '620512-14-6024';
            overridePayload.IdNo = '';            
          }                 

          // Test Case 2 (Existing client)
          if(this.testCase === '2') {
            let clientCode = 'T00C1G';

            let { data: draftResponse } = await this.$axios.get('/nf2f/retrievedraft', {
              params: { userId, clientCode }
            });

            let payload = draftResponse.ApplicationFormDetailsDto;

            let finalPayload = Object.assign({}, payload, defaultData);

            finalPayload['Nf2fApplicationDraftId'] = draftResponse.DraftId;
            finalPayload['PageIndicator'] = 'applicant_details';
            finalPayload['UserId'] = draftResponse.UserId;
            finalPayload['Name'] = overridePayload.Name;
            finalPayload['NewIdNo'] = overridePayload.NewIdNo;
            finalPayload['IdNo'] = overridePayload.IdNo;
            finalPayload['Email'] = 'ruennhuah.lee@affinhwang.com';

            let response = await this.$axios.post('/nf2f/SaveAsDraft', finalPayload);

            this.$router.push({ name: 'goRegistration', query: { userId, clientCode } });
          } 

          // Test Case 1 / 3 / 4 / 5 (New client)
          if(['1', '3', '4', '5'].findIndex(i => i === this.testCase) > -1) {
            let finalPayload = Object.assign({}, defaultData, overridePayload, { UserId: userId});

            await this.$axios.post('/NF2F/SaveAsDraft', finalPayload);

            this.$router.push({ name: 'goRegistration', query: { userId } });
          }


        } catch(error) {
          console.log(error);
          this.$bvToast.toast(`An error has occured whilst trying to emulate an existing user`, {
            title: 'An error has occured',
            variant: 'danger',
            autoHideDelay: 3500
          })
        }
      },


      async generateBlankUser() {
        try {
          let userId = shortid.generate(); 

          let response = await this.$axios.post('/NF2F/SaveAsDraft', {
            UserId: userId,
          });

          console.log(response);

        } catch(error) {
          console.log(error);
          this.$bvToast.toast(`An error has occured whilst trying to generate a new user`, {
            title: 'An error has occured',
            variant: 'danger',
            autoHideDelay: 3500
          })
        }
      }
    }
  }

</script>